import { ref, onMounted, onUnmounted } from 'vue'

/**
 * Returns a reactive boolean that is `true` when the viewport is narrower
 * than `breakpoint` pixels. Initialises synchronously from `window.matchMedia`
 * to avoid a layout flash on first render. The threshold is exclusive so that
 * `breakpoint = 768` matches Tailwind's `md:` boundary (max-width: 767px).
 */
export function useIsMobile(breakpoint = 768) {
  const query = `(max-width: ${breakpoint - 1}px)`

  const isMobile = ref(typeof window !== 'undefined' ? window.matchMedia(query).matches : false)

  let mql: MediaQueryList | undefined

  function onMqlChange(e: MediaQueryListEvent) {
    isMobile.value = e.matches
  }

  onMounted(() => {
    mql = window.matchMedia(query)
    isMobile.value = mql.matches
    mql.addEventListener('change', onMqlChange)
  })

  onUnmounted(() => {
    mql?.removeEventListener('change', onMqlChange)
  })

  return { isMobile }
}
